import React from 'react';
import 'Components/Modals/PaymentModal/index.css';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { FDStack } from '@facet-wealth/design';
import LeadPromoInput from 'Views/Page/Content/Templates/WizardTemplates/Buy/LeadPromoInput';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import LeadPromosLayout from './LeadPromoLayout';
import { leadPromoOverrides } from './leadPromoOverrides';

const LeadPromos = ({
  collection, refreshCollection, loading, setLoading,
}) => {
  return (
    <>
      <FDStack direction="column" spacing={1}>
        {collection.resources().list().map((res, i) => (
          <MetaFormInline
            key={res.id()}
            resource={res}
            padding="none"
            layout={LeadPromosLayout}
            index={i}
            noIndividualSubmitButtons
            noIndividualDeleteButtons
            onDelete={() => {
              // The agreement could have changed (because dollar amounts are in the agreement), so it must be refreshed
              refreshCollection();
            }}
            LayoutProps={{ collection, loading, setLoading }}
            metaOverrideSet={leadPromoOverrides}
          />
        ))}
      </FDStack>
      <LeadPromoInput collection={collection} refreshCollection={refreshCollection} loading={loading} setLoading={setLoading} />
    </>
  );
};

LeadPromos.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
  refreshCollection: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  setLoading: PropTypes.func.isRequired,
};

export default LeadPromos;
